import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  CircularProgress,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import { AMPLITUDE_KEYS, FEEDBACK_MESSAGES } from "../../../storage/constants";
import API from "../../../axios/instances/API";
import styled from "styled-components";
import { Plus } from "react-feather";
import * as amplitude from "@amplitude/analytics-browser";

const ModalWrapper = styled(Paper)`
  padding: 30px;
  min-width: min(600px, 96vw);
  max-width: 600px;
  text-align: left;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid black;
`;

const CHARACTER_LIMIT = 58;

const CreateStream = ({ setSnackbarText, setAddStreamOpen }) => {
  const [errorAlert, setErrorAlert] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [streamName, setStreamName] = useState("");
  const [charsMaxed, setCharsMaxed] = useState(false);
  const history = useHistory();

  const createStream = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorAlert(false);
    try {
      const { data } = await API.post("dashboard/streams/", {
        name: streamName,
      });
      amplitude.track(AMPLITUDE_KEYS.CREATED_STREAM);
      setIsSubmitting(false);
      setSnackbarText(`Successfully created stream "${streamName}" success`);
      setAddStreamOpen(false);
      history.push(`/streams/details/${data.id}`);
    } catch (error) {
      setIsSubmitting(false);
      setErrorAlert(true);
    }
  };

  const handleUpdateStreamName = (e) => {
    const { value } = e?.target;

    const numChars = value?.length || 0;

    if (numChars > CHARACTER_LIMIT) {
      return setCharsMaxed(true);
    }

    setCharsMaxed(false);
    setStreamName(value);
  };

  const buttonDisabled = streamName?.length < 3 || isSubmitting || charsMaxed;

  return (
    <ModalWrapper>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <Typography variant="h3">Create Stream</Typography>
      </div>
      <Typography variant="subtitle1">
        Fill out the field below to create a new Stream.
      </Typography>

      <form id="createStreamForm" onSubmit={createStream}>
        <TextField
          size="small"
          fullWidth
          autoFocus
          variant="outlined"
          sx={{ mt: 8 }}
          error={charsMaxed}
          helperText={
            charsMaxed &&
            `${CHARACTER_LIMIT} characters maximum for stream name`
          }
          label="New Stream Name"
          value={streamName}
          onChange={handleUpdateStreamName}
        />
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Button
            type="submit"
            form="createStreamForm"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: buttonDisabled ? "darkgrey" : "#337AB7",
              color: "#eeeeee",
              marginLeft: "auto",
            }}
            disabled={buttonDisabled}
            startIcon={
              isSubmitting ? (
                <CircularProgress size={16} sx={{ color: "white" }} />
              ) : (
                <Plus height={14} />
              )
            }
            sx={{ mt: 4 }}
          >
            {isSubmitting ? "Creating Stream" : "Create Stream"}
          </Button>
        </div>
      </form>
      {errorAlert && (
        <Alert
          severity="error"
          sx={{ mt: 2 }}
          onClose={() => setErrorAlert(false)}
        >
          {FEEDBACK_MESSAGES.GENERIC_ERROR}
        </Alert>
      )}
    </ModalWrapper>
  );
};

export default CreateStream;
